export default __webpack_public_path__ + "static/media/light-close.db043b3b.svg";